import React, { useState } from 'react';
import styles from '../../../../styles/usageRights.module.css';
import { Input } from '../../../styledComponents';

interface TermDropDownProps {
  options: { label: string; value: number | string }[];
  value: number;
  setValue: React.Dispatch<React.SetStateAction<number>>;
  inputPlaceholder?: string;
  setDropdownOpen: React.Dispatch<React.SetStateAction<boolean>>;
  width?: number;
}

function TermDropDown({ value, options, setValue, inputPlaceholder, setDropdownOpen, width }: TermDropDownProps) {
  const optionValues = options.reduce<(number | string)[]>((p, c) => {
    p.push(c.value);
    return p;
  }, []);
  const [inputValue, setInputValue] = useState(() => {
    if (!optionValues.includes(value)) return value;
    return '';
  });

  return (
    <div style={{ width }} className={styles.usageRightTermsDropdownContainer}>
      {options.map(({ label, value: v }) => (
        <div
          role="presentation"
          key={v}
          className={`${styles.usageRightTermsDropdownItem} ${
            value === v ? styles.usageRightTermsDropdownItemSelected : ''
          }`}
          onClick={() => {
            setValue(typeof v === 'string' ? parseFloat(v) : v);
            setDropdownOpen(false);
          }}
        >
          {label}
        </div>
      ))}
      <Input
        type="number"
        placeholder={inputPlaceholder}
        style={{ padding: '2px 8px 2px 8px', fontSize: '14px', fontWeight: 400 }}
        value={inputValue}
        onChange={(e) => {
          if (!e.target.value.length) return;
          setInputValue(e.target.value);
          setValue(parseFloat(e.target.value));
        }}
      />
    </div>
  );
}

export default TermDropDown;
